<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('grossProfit.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('grossProfit.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('grossProfit.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('grossProfit.date')
                      }}</label>
                      <a-range-picker
                        v-model="model.date_range"
                        class="ts-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                      />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        ><i class="fas fa-file-excel"></i>
                        {{ $t('excel') }}</ts-button
                      >
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        ><i class="fas fa-file-pdf text-red"></i>
                        {{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('grossProfit.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'grossProfit',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: null,
      errors: new Errors(),
      vendors: [],
      model: {
        date_range: [
          moment()
            .startOf('M')
            .format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY')
        ]
      }
    }
  },
  methods: {
    ...mapActions('report/finance', ['grossProfit']),
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.grossProfit(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/finance/grossProfitExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
